<template>
    <div class="SwitchTemplate">
        <div class="SwitchTemplate_title">
            <p>推荐模板</p>
        </div>
        <ul class="SwitchTemplate_ul">
            <li class="SwitchTemplate_li" v-for="item in data" :key="item.id">
                <img :src="item.img" alt="" class="SwitchTemplate_li_bg"/>
                <p>{{item.name}}</p>
                <div class="SwitchTemplate_li_con">
                    <div @click="useTemplate(item)">使用模板</div>
                    <div @click="preViewTemplate(item)">预览</div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import data from './data.js'
export default {
    name: 'SwitchTemplate',
    props: {
        data: {
            type: Array,
            default: () => {
                return data
            }
        }
    },
    methods: {
        useTemplate(item) {
            this.$emit('change', item)
        },
        preViewTemplate(item){
            this.$emit('preview', item)
        }
    }
}
</script>
<style lang="less" scoped>
    .SwitchTemplate {
        border: 1px solid #e3e5ee;
        margin-bottom: 5px;
        border-radius: 4px;
        box-sizing: content-box;
        display: flex;
        .SwitchTemplate_title {
            margin-top: -1px;
            width: 32px;
            border-radius: 4px 0 0 4px;
            background: #e3e5ee;
            p{
               color: #888a95;
                font-size: 14px;
                width: 27px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                padding-top: 20px;
            }
        }
        .SwitchTemplate_ul {
            padding: 5px 0 7px 5px;
            box-sizing: border-box;
            display: flex;
            overflow-y: hidden;
        }
        .SwitchTemplate_li {
            box-sizing: border-box;
            display: flex;
            margin-right: 8px;
            height: 108px;
            border-radius: 4px;
            overflow: hidden;
            flex-shrink: 0;
            position: relative;
            p {
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 24px;
                font-size: 12px;
                line-height: 24px;
                text-align: center;
                color: #fff;
                z-index: 10;
            }
            .SwitchTemplate_li_con {
                box-sizing: border-box;
                width: 192px;
                height: 100%;
                background: rgba(0,0,0,.4);
                // border-radius: 4px;
                position: absolute;
                top: 0;
                left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                transform: translateY(calc(100% - 24px));
                transition: all 200ms linear;
                div {
                    background: #000;
                    width: 86px;
                    height: 32px;
                    border-radius: 4px;
                    color: #fff;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                    margin-bottom: 10px;
                }
             }
            &:hover .SwitchTemplate_li_con{
                 transform: translateY(0%);
            }
        }
        .SwitchTemplate_li_bg {
            width: 192px;
            height: 100%;
            border-radius: 0 0 4px 4px;
        }
    }
</style>